import { render, staticRenderFns } from "./2018.vue?vue&type=template&id=5e1b7b20&"
import script from "./2018.vue?vue&type=script&lang=js&"
export * from "./2018.vue?vue&type=script&lang=js&"
import style0 from "./2018.vue?vue&type=style&index=0&id=5e1b7b20&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports